/**
 * Created by Amit
 */



require("pixi-particles");

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {PixiesVsPiratesGameConfig} from "../../PixiesVsPiratesGameConfig";

export class PPMegaParticles extends BaseView {

    private readonly _screenHeightRange:[number, number] = [720, 1760];
    private readonly _startSpeedRange:[number, number] = [650, 950];
    private _emitter:Emitter;
    private readonly _particleConfig:any = {
        "alpha": {
            "start": 0.57,
            "end": 1
        },
        "scale": {
            "start": 0.75,
            "end": 0.001,
            "minimumScaleMultiplier": 3
        },
        "color": {
            "start": "#ffe385",
            "end": "#ffae00"
        },
        "speed": {
            "start": 400,
            "end": 1,
            "minimumSpeedMultiplier": 3
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 0,
            "max": 360
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 0
        },
        "lifetime": {
            "min": 0.2,
            "max": 1
        },
        "blendMode": "add",
        "frequency": 0.001,
        "emitterLifetime": -1,
        "maxParticles": 50,
        "pos": {
            "x": GameConfig.instance.GAME_WIDTH * 0.5,
            "y": GameConfig.instance.GAME_HEIGHT * 0.5
        },
        "addAtBack": false,
        "spawnType": "point"
    };

    private _layer:ScalableLayer;

    private _isPlaying:boolean = false;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.BIG_WIN.name);
        this._emitter = new Emitter(this._layer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : GameResources.getTextures("softparticle")
        }], this._particleConfig);
        this._emitter.particleConstructor = AnimatedParticle;
        ParticlesManager.addEmitter(this._emitter, false);
    }

    public startAnimation():void {
        this._emitter.emit = true;
        this._isPlaying = true;
    }

    public stopAnimation():void {
        this._emitter.cleanup();
        this._isPlaying = false;
        this._emitter.emit = false;
    }

    protected onResize(resizeData:IResizeData):void {
        // this._resizeData = resizeData;
        //
        // if(!this._isPlaying) {
        //     this._isResizeDirty = true;
        //     return;
        // }
        //
        // this._isResizeDirty = false;
        // let screenHeight:number = Math.round(resizeData.height / this._layer.scale.y);
        // screenHeight = Math.max(this._screenHeightRange[0], Math.min(screenHeight, this._screenHeightRange[1]));
        // const startSpeed:number = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);
        // const y:number = Math.round((resizeData.height - this._layer.y) / this._layer.scale.y) + 40;
        // const levelSpeed:number = startSpeed * (1 + 0.05);
        // this._emitter.cleanup();
        // this._emitter.startSpeed = levelSpeed;
        // this._emitter.endSpeed = levelSpeed;
        // this._emitter.spawnPos.y = y;
    }
}